// reducers.js
import config from 'config'

import {
  GET_OUTPUT,
  GET_OUTPUT_FAIL,
  GET_OUTPUT_SUCCESS,
  GET_RC_USER_DATA,
  GET_RC_USER_DATA_FAIL,
  GET_RC_USER_DATA_SUCCESS,
  GET_RCLOOKUPDATA,
  GET_RCLOOKUPDATA_FAIL,
  GET_RCLOOKUPDATA_SUCCESS,
  SET_USER_RC_DATA_FAIL,
  SET_USER_RC_DATA_SUCCESS,
  VALIDATE,
  CHANGE_INPUT,
  RESET_SAVE_SUCCESS,
} from 'state/action-types.js'


const initialState = {
  name: false,
  session: null,
  data: [],
  error: {
    hasError: false,
    message: '',
  },
  chartData: [],
  sensitivityData: {},
  totalContributionsTaxable: 0,
  totalContributionsNonTaxable: 0,
  totalTaxable: 0,
  totalNonTaxable: 0,
  retirementAge: 0,
  retirementAnnualIncome: 0,
  afterTaxContributions: 0,
  forecast: {},
  return_and_tax: {},
  agg_tax_type: {},
  userData: {},
  uid: null,
  input: {},
  isValidated: true,
  saveSuccess: false
}

// Never mutate original state passed in. Read
// on redux principles
function reducer(state = initialState, action){

  switch (action.type) {

    case GET_OUTPUT_SUCCESS: {
      return Object.assign({}, state, {
        chartData: action.chartData,
        sensitivityData: action.sensitivityData,
        totalContributionsTaxable: action.totalContributionsTaxable,
        totalContributionsNonTaxable: action.totalContributionsNonTaxable,
        retirementAge: action.retirementAge,
        retirementAnnualIncome: action.retirementAnnualIncome,
        afterTaxContributions: action.afterTaxContributions,
        totalTaxable: action.totalTaxable,
        totalNonTaxable: action.totalNonTaxable,
        error: action.error
      })
    }

    case GET_OUTPUT_FAIL: {
      return Object.assign({}, state, {
        error: action.error
      })
    }

    case GET_RCLOOKUPDATA_SUCCESS: {
      var dropdownData = action.dropdownData
      var forecast = [] 
      var return_and_tax = [] 
      var agg_tax_type  = []
      Object.keys(dropdownData).map(dropdown => {
        switch(dropdownData[dropdown].TypeName){
          case "Forecast": {
            var list = {
              forecast: dropdownData[dropdown].Value,
              text: dropdownData[dropdown].Value,
              key: dropdownData[dropdown].Key
            }
            forecast.push(list)
            break
          }

          case "Return and tax calculation": {
            return_and_tax.push(dropdownData[dropdown].Value)
            break
          }

          case "Aggregate tax type": {
            var list = {
              value: dropdownData[dropdown].Value,
              key: dropdownData[dropdown].Key
            }

            agg_tax_type.push(list)
            break
          }
        }    
      })
      return Object.assign({}, state, {
        forecast: forecast,
        return_and_tax: return_and_tax,
        agg_tax_type: agg_tax_type
      })
    }

    case GET_RC_USER_DATA_SUCCESS: {
      var isValidated = initialState.isValidated
      if(action.userData.success == 0)
        isValidated = false

      return Object.assign({}, state, {
        userData: action.userData,
        isValidated: isValidated
      })
    }

    case SET_USER_RC_DATA_SUCCESS: {
      return Object.assign({}, state, {
        error: action.error,
        saveSuccess: action.saveSuccess,
      })
    }

    case SET_USER_RC_DATA_FAIL: {
      return Object.assign({},state, {
        error: action.error
      })
    }

    case VALIDATE: {
      return Object.assign({}, state, {
        uid: action.uid
      })
    }

    case CHANGE_INPUT: {
      return Object.assign({}, state, {
        input: action.input
      })
    }

    case RESET_SAVE_SUCCESS: {
      return Object.assign({}, state, {
        saveSuccess: false
      })
    }
  }

  return state
}

export { initialState, reducer }


// WEBPACK FOOTER //
// ./state/reducers.js